import {
	clearPersistedCart,
	slimCart,
	slimPersistedState,
} from './cartSnapshot'

// 與舊 key 分開：退版時舊 bundle 只讀舊 key，不會讀到瘦身後它看不懂的購物車結構
export const USER_PERSIST_KEY = 'byod:user'
const LEGACY_PERSIST_KEY = 'vuex'

/**
 * user 模組的 vuex-persist 選項（localStorage）：存瘦身後的購物車、從舊 key 遷移、寫入失敗不中斷 commit。
 */
export function createUserPersistenceOptions(storage) {
	return {
		key: USER_PERSIST_KEY,
		storage,
		reducer: state => ({
			user: { ...state.user, cart: slimCart(state.user.cart) },
		}),
		restoreState: () => restoreUserState(storage),
		// vuex-persist 同步寫入且不攔例外，額度用盡時 QuotaExceededError 會拋回 commit 的呼叫端
		saveState: (key, state) => {
			if (!writeJson(storage, key, state)) {
				console.error(`[persist] ${key} 寫入 localStorage 失敗`)
			}
		},
	}
}

/**
 * 優先讀新 key；新 key 不存在時從舊 key 遷移整份 user 模組（只瘦身購物車）。
 *
 * 順序不可對調：新舊 key 共用 iOS 約 5 MB 的網域額度，舊 key 接近上限的顧客（正是需要遷移的人）
 * 若先寫新 key 會寫不進去、也就走不到釋放舊 key。故先在記憶體組好新 state，清掉舊 key 的購物車釋放空間，
 * 再寫新 key；中途中斷最壞只遺失購物車，登入與遊客身分仍在。
 */
export function restoreUserState(storage) {
	const current = readJson(storage, USER_PERSIST_KEY)
	const legacy = readJson(storage, LEGACY_PERSIST_KEY)
	if (current) {
		// 退版期間舊 bundle 又寫回舊 key 的購物車，新版不讀它，只釋放空間
		if (hasCart(legacy)) {
			writeJson(storage, LEGACY_PERSIST_KEY, clearPersistedCart(legacy))
		}
		return current
	}
	if (!legacy) return {}

	const migrated = slimPersistedState(legacy)
	writeJson(storage, LEGACY_PERSIST_KEY, clearPersistedCart(legacy))
	if (!writeJson(storage, USER_PERSIST_KEY, migrated)) {
		console.error(`[persist] 購物車遷移寫入 ${USER_PERSIST_KEY} 失敗`)
	}
	return migrated
}

function hasCart(persisted) {
	const cart = persisted?.user?.cart
	return (
		!!cart &&
		Object.values(cart).some(
			stores =>
				stores &&
				Object.values(stores).some(
					items => Array.isArray(items) && items.length,
				),
		)
	)
}

function readJson(storage, key) {
	try {
		const value = storage.getItem(key)
		return value ? JSON.parse(value) : null
	} catch (e) {
		return null
	}
}

function writeJson(storage, key, value) {
	try {
		storage.setItem(key, JSON.stringify(value))
		return true
	} catch (e) {
		return false
	}
}
